export const PublishOptionHeader = ({
    step1_disabled_true,
    step2_disabled_true,
    step2_disabled_true_class,
    step3_disabled_true_class,
    purpose,
}: {
    step1_disabled_true: boolean;
    step2_disabled_true: boolean;
    step2_disabled_true_class: boolean;
    step3_disabled_true_class: boolean;
    purpose?: DATA.PurposeType;
}) => {
    return (
        <div className="flex_b option_header">
            <ul className="step_tab flex_c">
                <li className="step-1 on">
                    <span className={`circle ${step1_disabled_true && 'active'}`}>
                        <span className="num">1</span>
                    </span>
                    <span className="num_step">STEP 1</span>
                </li>
                {purpose !== 'output' && (
                    <li className={`step-2 ${step1_disabled_true && 'on'}`}>
                        <span
                            className={`circle ${(step2_disabled_true || step2_disabled_true_class) && 'active'}`}
                        >
                            <span className="num">2</span>
                        </span>
                        <span className="num_step">STEP 2</span>
                    </li>
                )}
                {purpose === 'class' && (
                    <li
                        className={`step-3 ${(step2_disabled_true || step2_disabled_true_class) && 'on'}`}
                    >
                        <span className={`circle ${step3_disabled_true_class && 'active'}`}>
                            <span className="num">3</span>
                        </span>
                        <span className="num_step">STEP 3</span>
                    </li>
                )}
            </ul>
        </div>
    );
};
